import React from 'react';
import MediaQuery from 'react-responsive';

import Button from '../../../components/UI/Button/Button';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Checkbox from '../../../components/UI/Checkbox/Checkbox';
import DatePicker from '../../../components/UI/DatePicker/DatePicker';
import Aux from '../../../hoc/Auxi/Auxi';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Hobby in candidate profile section
* @param props
* @return DOM element
*/
const Hobby = (props) => {
  return (
    <div>
      <Textbox label={"Interest " + parseInt(props.index + 1)} placeholder="" value={props.hobby} onChange={(event) => props.handleHobbyChange(event, props.index)} onBlur={(event)=>props.handleHobbiesOnBlur(event)} inValid={props.inValid}/>
    </div>
  )
}

/**
* @desc Hobbies in candidate profile section
* @param props
* @return DOM element
*/
const Hobbies = (props) => {
  const updateText = props.hobbiesActive =="updated" ? "Updated" : "Update";
  const inValid = props.errorMsg !== null && props.errorPosition === "hobby";
  const disabled = props.hobbiesActive =="update" ? 'disabled' : "";
  
  return (
    <Aux>
      <div className="profile-edit__item"> 
        <MediaQuery query="(min-device-width: 768px)">
          <FormGrid grid="auto auto auto">
            {props.candidate.hobbies.map((hobby, index) => (
              <Hobby key={index}  index={index} hobby={hobby} 
                handleHobbyChange={props.handleHobbyChange} 
                inValid={inValid?"Invalid":""}
                handleHobbiesOnBlur={props.handleHobbiesOnBlur}
              />
            ))}
          </FormGrid>
        </MediaQuery>        
        <MediaQuery query="(max-device-width: 767px)">
          <FormGrid grid="auto">
            {props.candidate.hobbies.map((hobby, index) => (
              <Hobby key={index} index={index} hobby={hobby} 
                handleHobbyChange={props.handleHobbyChange}  
                inValid={inValid?"Invalid":""}
                handleHobbiesOnBlur={props.handleHobbiesOnBlur}
              />
            ))}
          </FormGrid>
        </MediaQuery>   
      </div>
      <div className="profile-edit__section__buttons">
        <MediaQuery query="(min-device-width: 768px)">
          <Button 
            uistyle="secondary" 
            className="profile-edit__add-button" 
            onClick={props.addHobby}
          >+ Add Interest</Button>
        </MediaQuery>        
        <MediaQuery query="(max-device-width: 767px)">
          <Button 
            uistyle="secondary" 
            className="profile-edit__add-button" 
            buttonicon="add" 
            buttonIconAlone={true} 
            onClick={props.addHobby}
          ></Button>
        </MediaQuery>  
        <Button 
          className={props.hobbiesActive} 
          disabled={disabled} 
          onClick={(event)=>props.handleUpdateProfile(event,"hobbiesActive")}
        >{updateText}</Button>
      </div>
    </Aux>
  );
}

export default Hobbies;



// WEBPACK FOOTER //
// ./src/components/Recruiter/Hobbies/Hobbies.js